import style from './SwitchField.css'

class SwitchField extends React.Component {
  render () {
    let {input, onText = 'ON', offText = 'OFF', discount} = this.props
    return <label className={`${discount ? style.switch : style['switch-large']}`}>
      <input {...input} type='checkbox' />
      <div className={`${discount ? style.slider : style['slider-large']} col-sm-12`}>
        <div className={`${discount ? style.on : style['on-large']}`}>{onText}</div>
        <div className={`${discount ? style.middle : style['middle-large']}`}>&nbsp;</div>
        <div className={`${discount ? style.off : style['off-large']}`}>{offText}</div>
      </div>
    </label>
  }
}

export default SwitchField



// WEBPACK FOOTER //
// ./app/components/Fields/ReduxForm/SwitchField/SwitchField.js